$(document).ready(function(){
    if($(".block__shopify-product-audit-main-bundle-exp-date-js").length){
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        var lastDay = new Date(y, m + 1, 0);
        var month_name = lastDay.toLocaleString("en-US", { month: "long" });
        var month_year = lastDay.getFullYear();
        var month_end_date = lastDay.getDate();
        $(".block__shopify-product-audit-main-bundle-exp-date-js").text(month_name+" "+month_end_date+", "+month_year);
    }
    
    setInterval(function(){
        if(!$(".block__shopify-product-audit-images-slider-one").hasClass("slick-initialized")){
            $(".block__shopify-product-audit-images-slider-one").slick({
                draggable: false,
                infinite: true,
                autoplay: true,
                arrows: false,
                autoplaySpeed: 0,
                speed: 8000,
                slidesToShow: 3,
                pauseOnHover:false,
                cssEase: 'linear',
                vertical: true
            });
        }
    }, 1000)

    setInterval(function(){

    if(!$(".block__shopify-product-audit-images-slider-two").hasClass("slick-initialized")){
        $(".block__shopify-product-audit-images-slider-two").slick({
            draggable: false,
            infinite: true,
            autoplay: true,
            arrows: false,
            autoplaySpeed: 0,
            speed: 8000,
            slidesToShow: 3,
            pauseOnHover:false,
            cssEase: 'linear',
            vertical: true
        });
    }
}, 1000)
setInterval(function(){
    if(!$(".block__shopify-product-audit-images-slider-three").hasClass("slick-initialized")){
        $(".block__shopify-product-audit-images-slider-three").slick({
            draggable: false,
            infinite: true,
            autoplay: true,
            arrows: false,
            autoplaySpeed: 0,
            speed: 8000,
            slidesToShow: 3,
            pauseOnHover:false,
            cssEase: 'linear',
            vertical: true
        });
    }
}, 1000)
    $(".block__shopify-single-product-audit-images-slider").each(function(){
        var $this = $(this);
        if(!$this.hasClass("slick-initialized")){
            $this.slick({
                draggable: false,
                infinite: true,
                autoplay: true,
                arrows: false,
                autoplaySpeed: 0,
                speed: 6000,
                pauseOnHover:false,
                slidesToShow: 4,
                cssEase: 'linear',
                vertical: true,
                responsive: [
                    {
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 1,
                        vertical: false
                      }
                    }
                ]
            });
        }
    });
});

$(window).on('load', function(){
    checkBorwser(); 
})
$(document).ready(function(){
    checkBorwser(); 
});
function checkBorwser(){
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
        console.log('Opera');
      } else if (navigator.userAgent.indexOf("Edg") != -1) {
        console.log('Edge');
        $('.block__shopify-product-audit-main-bundle-products-box').addClass('block__shopify-product-audit-main-bundle-products-scroll-cs'); 
        $('.block__shopify-product-audit-bundle-products').addClass('block__shopify-product-audit-main-bundle-products-scroll-cs')
      } else if (navigator.userAgent.indexOf("Chrome") != -1) {
          $('.block__shopify-product-audit-main-bundle-products-box').addClass('block__shopify-product-audit-main-bundle-products-scroll-cs'); 
          $('.block__shopify-product-audit-bundle-products').addClass('block__shopify-product-audit-main-bundle-products-scroll-cs')
        console.log('Chrome');
      } else if (navigator.userAgent.indexOf("Safari") != -1) {
          $('.block__shopify-product-audit-main-bundle-products-box').addClass('block__shopify-product-audit-main-bundle-products-scroll-sfr'); 
          $('.block__shopify-product-audit-bundle-products').addClass('block__shopify-product-audit-main-bundle-products-scroll-sfr')
        console.log('Safari');
      } else if (navigator.userAgent.indexOf("Firefox") != -1) {
       $('.block__shopify-product-audit-main-bundle-products-box').addClass('block__shopify-product-audit-main-bundle-products-ff'); 
       $('.block__shopify-product-audit-bundle-products').addClass('block__shopify-product-audit-main-bundle-products-scroll-prd-ff')
      } else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) //IF IE > 10
      {
        console.log('IE');
      } else {
        console.log('unknown');
      }
}

var sc;
jQuery(document).ready(function(){
    //constantly update the scroll position:
    sc=setInterval(scrollDown,200);

    //optional:stop the updating if it gets a click
    jQuery('.block__shopify-product-audit-main-bundle-products-ff, .block__shopify-product-audit-main-bundle-products-scroll-prd-ff').mousedown(function(e){
        clearInterval(sc);            
    });
});
function scrollDown(){
    //find every div with class "mydiv" and apply the fix
    for(i=0;i<=jQuery('.block__shopify-product-audit-main-bundle-products-ff, .block__shopify-product-audit-main-bundle-products-scroll-prd-ff').length;i++){
        try{
            var g=jQuery('.block__shopify-product-audit-main-bundle-products-ff, .block__shopify-product-audit-main-bundle-products-scroll-prd-ff')[i];
            g.scrollTop+=1;
            g.scrollTop-=1;
        } catch(e){
            //eliminates errors when no scroll is needed
        }
    }
}
